import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { PostEscalationCurationActions } from './post-escalation-curation.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { PostEscalationCurationEffects } from './post-escalation-curation.effects';
import { ChatAdminActions } from '../chat-admin/chat-admin.actions';

export const initialState: Readonly<PostEscalationCuration> = {
  curationList: [],
  postEscalationSelection: {
    category: '',
    product: '',
    specificProduct: '',
    departmentId: '',
    platform: '',
    aaEligible: false,
  },
};

export const postEscalationCurationFeature = createFeature({
  name: 'postEscalationCuration',
  reducer: createReducer(
    initialState,
    on(ChatAdminActions.updateResponse, (state, { value }) => {
      return { ...state, curationList: value.curationList };
    }),
    on(
      PostEscalationCurationActions.updateSelectedItems,
      (state, { value }) => {
        return { ...state, postEscalationSelection: value };
      }
    )
  ),
});

export const { selectPostEscalationCurationState, selectCurationList } =
  postEscalationCurationFeature;

export function providePostEscalationCurationFeature() {
  return makeEnvironmentProviders([
    provideState(postEscalationCurationFeature),
    provideEffects(PostEscalationCurationEffects),
  ]);
}
